import React, { useEffect, useRef, useState } from "react";
import { WatchPackageInfo } from "../../../interface/site.interface";
import { ReferalServices } from "../../../services/referal.service";
import { useParams } from "react-router-dom";
import styles from "./WatchPackages.module.scss";
import OrderRow from "../../../components/pages/courier/OrderRow";
import Spinner from "../../../components/shared/spinner/Spinner";
import { PackagesService } from "../../../services/packages.service";
import slider from "../../../assets/images/user-admin-panel/my-packages/Sliders.svg";
import Card from "../../../components/pages/card/Card";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const WatchPackages: React.FC = () => {
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [referalPackages, setReferalPackages] = useState<WatchPackageInfo[]>(
    []
  );
const language = useSelector((state: RootState) => state.language.language);
  const [filters, setFilters] = useState(false);
  const [packagesType, setPackagesType] = useState([]);
  const filterRef = useRef<HTMLDivElement>(null);
  const [selectedStatus, setSelectedStatus] = useState<{
    key: string;
    label: string;
  }>({
    key: "baku",
    label: "Bakıya çatıb",
  });

  const { id } = useParams();

  useEffect(() => {
    if (id && selectedStatus?.key) {
      setPackagesLoading(true);
      ReferalServices.Watch_ReferalPackages(selectedStatus.key, id)
        .then((res) => {
          setReferalPackages(res.data.original.packages.data);
        })
        .catch(() => setReferalPackages([]))
        .finally(() => setPackagesLoading(false));
    }
  }, [id, selectedStatus, language]);

  useEffect(() => {
    PackagesService.getAllPackagesType().then((res) => {
      const statusOptions = res.data.data.map(
        (type: { key: string; label: string }) => ({
          key: type.key,
          label: type.label,
        })
      );

      setPackagesType(statusOptions);

      const defaultStatus = statusOptions.find(
        (option: any) => option.key === "baku"
      );
      if (defaultStatus) {
        setSelectedStatus(defaultStatus);
      }
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        setFilters(false);
      }
    };

    if (filters) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filters]);

  return (
    <div id={styles.order_list}>
      <div className={styles.head}>
        <h3 className={styles.title}>Bağlamalar</h3>
        <div className={styles.icon} onClick={() => setFilters(!filters)}>
          <img src={slider} alt="filter" />
        </div>
      </div>
      {filters && (
        <div ref={filterRef} className={styles.filters}>
          <div className={styles.status_lists}>
            {packagesType.map((el: { label: string; key: string }) => (
              <div
                key={el.key}
                className={`${styles.st_list} ${
                  selectedStatus.key === el.key ? styles.active : ""
                }`}
                onClick={() => {
                  setSelectedStatus(el); 
                  setFilters(false); 
                }}
              >
                {el.label}
              </div>
            ))}
          </div>
        </div>
      )}
      {packagesLoading ? (
        <Spinner size="large" />
      ) : referalPackages?.length !== 0 ? (
        <table className={styles.order_history_list}>
          <thead>
            <tr>
              <th>Taking number</th>
              <th>Tarix</th>
              <th>Çəki</th>
              <th>Çatdırılma məbləği</th>
              <th>İnvoys</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {referalPackages?.map((order, index) => (
              <OrderRow key={index} {...order} watchPackages={true} />
            ))}
          </tbody>
        </table>
        
      ) : (
        <div className={styles.empty}>Bağlamanız yoxdur.</div>
      )}
      <div className={styles.courier_card}>
            {referalPackages?.map((order, index) => (
              <Card key={index} {...order} RefList={true} />
            ))}
          </div>
    </div>
    
  );
};

export default WatchPackages;
